import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {FormModel} from "../models/constants";
import {PropertyModel} from "../models/property-model";
import {TranslateService} from "@ngx-translate/core";
import {Observable} from "rxjs";
import {environment} from "../../../../environments/environment";

@Injectable()
export class PropertyService {
    private readonly apiUrl = '/api/properties';

    constructor(private http: HttpClient,
                private translateService: TranslateService) {
    }

    postProperties(model: any) {
        return this.http.post<any>('/api/properties', model);
        /*
        .toPromise()
        .then(res => res.data as any[])
        .then(data => data)
        */
    }

    getProperties(): Observable<any> {
        return this.http.get<any>(this.apiUrl + "/keys");
    }


    getPropertiesByKey(key: string) {
        return this.http.get<PropertyModel[]>(this.apiUrl + '/' + key + '/list')
            .toPromise()
            .then(data => {
                data?.forEach(item => {
                    item.dtext = item.dtext?.replace('&gt;', '>');
                });
                return data;
            });
    }


    async getPropertyListByKey(key: string) {
        let language = this.translateService.currentLang;

        if (!language) {
            language = this.translateService.defaultLang;
        }

        return await this.getPropertiesByKey(key).then(value => {
            if (key.localeCompare("subtype") == 0) {
                console.log(key)
            }

            let model: FormModel[] = [];
            const result = value;

            const lang = language ? language.toLowerCase() : null;

            result?.forEach((item, index) => {
                const label = item.languageWertMap
                    ? lang && environment.globalLanguages.includes(lang) && item.languageWertMap[lang]
                        ? item.languageWertMap[lang] // Use the selected language if available
                        : item.languageWertMap['en'] || item.dtext // Fallback to 'en' or dtext
                    : item.dtext;

                model.push({
                    id: item.id,
                    value: item.dkey,
                    label: label
                });
            });

            return model;

        });
    }


    async getPointsweightByPropertyKey(key: string, selectedItems: string[]) {
        return await this.getPropertiesByKey(key).then(value => {
            const selectedProperties = value?.filter(x => selectedItems.includes(x.dkey));

            let counter = 0;
            selectedProperties?.forEach(points => {

                counter += Number(points.weighting);
            })
            return counter;

            /*            let totalPoints: number = selectedProperties.reduce((counter, currentItem) => counter + currentItem.weighting, 0);
                        console.log(totalPoints)
                        return totalPoints;*/
        });
    }

}
